module.exports = __webpack_public_path__ + "static/media/verizon-router-front.4f72b767.png";